// Teaboy logo — displayed on a dark plate for legibility since the wordmark has white text.
export default function Logo({ size = "md", plate = true, className = "" }) {
  const heights = { sm: "h-8", md: "h-10", lg: "h-16", xl: "h-24" };
  const pads = { sm: "px-3 py-1.5", md: "px-4 py-2", lg: "px-6 py-3", xl: "px-8 py-4" };
  const h = heights[size] || heights.md;
  const p = pads[size] || pads.md;
  return (
    <div
      className={`inline-flex items-center ${plate ? `${p} bg-[hsl(var(--brand-plate))]` : ""} ${className}`}
      data-testid="teaboy-logo"
    >
      <img src="/teaboy-logo.png" alt="Teaboy" className={`${h} w-auto object-contain`} />
    </div>
  );
}
